<template>
  <div class="alertas">
    <div v-if="sensorsError.length > 0" class="alert alert-danger">
      <h3>{{$t("message.sensorsWithError")}}</h3>
      <ul>
        <li
          v-for="(sensorError,index) of sensorsError"
          :key="index"
        >{{$tc("sensors."+sensorError.sensorDescription, 1)}} {{sensorError.id}}</li>
      </ul>
    </div>
    <div v-if="sensorsTriggered.length > 0" class="alert alert-warning">
      <h3>{{$t("message.sensorsTriggered")}}</h3>
      <ul>
        <li
          v-for="(sensorTriggered,index) of sensorsTriggered"
          :key="index"
        >{{$tc("sensors."+sensorTriggered.sensorDescription, 1)}} {{sensorTriggered.id}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Alertas",
  computed: {
    ...mapGetters(["sensorsError", "sensorsTriggered"])
  }
};
</script>

<style>
</style>
